import { useMemo, useState } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import Pagination from "@/components/Pagination/Pagination"
import { MODALS } from "@/constants/modals"
import TicketsFilter from "@/features/pages/Tickets/TicketsFilter"
import TicketsShow from "@/features/pages/Tickets/TicketsShow"
import style from "@/features/pages/Tickets/TicketsStyle.module.css"
import { useTicketsData } from "@/queries/queries"
import type { Ticket } from "@/types/ticketTypes"
import { useStore } from "@/zustand/store"

export default function Tickets() {
  const ticketQuery = useTicketsData()

  const [filter, setFilter] = useState("")

  const { t, i18n } = useTranslation()

  const editModalState = useStore((state) => state.editModalState)

  const filterdDate = useMemo(() => {
    if (!ticketQuery.data) return [] as Array<Ticket>
    if (filter === "") {
      return ticketQuery.data.data
    }
    return ticketQuery.data.data.filter((ele) => String(ele.status) == filter)
  }, [filter, ticketQuery.data])

  let content
  if (ticketQuery.isLoading) {
    content = <Loading />
  } else if (!ticketQuery.data || !filterdDate.length) {
    content = <NoMessage name={t("noMessages.tickets")} />
  } else {
    content = (
      <>
        <TicketsShow tickets={filterdDate} />
        <Pagination pagination={ticketQuery.data.meta} route="tickets" />
      </>
    )
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bolder mb-0">{t("ticketsPage.title")}</h5>
      </div>
      <TicketsFilter filter={filter} setFilter={setFilter} />
      {content}
      <OverlayTrigger
        placement={i18n.language === "ar" ? "right" : "left"}
        overlay={
          <Tooltip
            id="tooltip"
            style={{
              backgroundColor: "white",
              color: "black",
              border: "1px solid #ddd",
              position: "fixed",
            }}
          >
            {t("ticketsPage.newTicketTooltip")}
          </Tooltip>
        }
      >
        <div
          onClick={() => editModalState(MODALS.tickets.add, true)}
          className={style["new-ticket"]}
          style={i18n.language === "ar" ? { left: "20px" } : { right: "20px" }}
        >
          <img src="/assets/images/new.gif" alt="" />
        </div>
      </OverlayTrigger>
    </div>
  )
}
